export const enTranslation = {
    catalog: {
        filters: {
            title: 'ADVISOR CATEGORIES',
            results: '{{number}} results',
            label: 'Filters {{number}}'
        },
        pageTitle: " Connecting you to the spirit realm for love, finances + life's purpose",
        pageTopTitle: 'Empathy Meets AI',
        collageTitle: 'Enlighten Your Journey with Our AI Spiritual Guides',
        collageSubTitle: 'Cultivate Love, Compassion, and Fulfilling Relationships',
        cardTitle: "Unlocking Love's Oracle: AI Spiritual Guides for You",
        bigCardTitle: "This Month's Featured AI Spiritual Guide",
        bigCardTitle2: 'Meet Aviva, our AI Intimacy Expert',
        bigCardTitleText: 'Dream Interpreter',
        bigCardTitle2Text: 'Intimacy Coach',
        paymentHistory: 'Payments history',
        multiTitle: 'Start a Group Chat',
        multiSubtitle: 'Deepen your relationships + Uncover unique insights'
    },
    buttons: {
        chatNow: 'chat now',
        multiChat: 'Start Multichat',
        spiritGuides: 'Meet Our AI Spiritual Guides',
        logout: 'Log out',
        freeTrial: 'Start Free {{trialDays}}-day Trial',
        freeTrial_offer: 'Start for Free',
        offer: 'Get offer',
        getOffer: 'Get it now',
        feedback: 'Feedback',
        privacy: 'Privacy',
        privacyPolicy: 'Privacy Policy',
        termsOfService: ' Terms of Service',
        google: 'Continue with Google',
        facebook: 'Continue with Facebook',
        submit: 'SUBMIT',
        submitSm: 'Submit',
        send: 'SEND',
        moreInfo: 'Add birth time information for a more accurate reading',
        resend: 'Resend message',
        backHome: 'Back home',
        toHome: 'To home page',
        save33: 'Save 33% Now!',
        save: 'Save changes',
        manage: 'Manage Subscription',
        removeAcc: 'Delete account',
        cancel: 'Cancel',
        confirmDelete: 'Confirm deletion',
        msgSub: 'Subscription management',
        subscribe: 'Subscribe',
        retry: 'Retry',
        retrySubscription: 'Retry subscription',
        paymentsHistory: 'Payments history',
        cancelSubscription: 'Cancel subscription',
        creditCard: 'Credit card',
        share: 'Share',
        invite: 'Invite Friends',
        inviteOphelia: 'Start Group Tarot',
        inviteVeda: 'Start Group Horoscope',
        inviteAtlas: 'Get Insights',
        rate: 'Rate',
        joinChat: 'JOIN CHAT',
        tryAgain: 'Try again',
        noThanks: 'No, thanks'
    },
    footer: {
        about: 'About us',
        contact: 'Contact us',
        advertising: 'Advertising',
        privacy: 'Privacy',
        terms: 'Terms'
    },
    menu: {
        title: 'Menu',
        catalog: 'Catalog',
        profile: 'Profile',
        profileCreate: 'Create Profile',
        newChat: 'Start New Chat',
        history: 'Chat History'
    },
    errors: {
        birthPlace: 'Please enter your birthplace',
        number: 'Phone number must contain at least 6 numbers',
        wrong: 'Something went wrong...',
        wrong404: 'Something went wrong',
        changed: 'Chat name was changed',
        notEmptyMessage: 'Message cannot be just spaces',
        maxSymbolMessage: 'The max length of 2000 characters is reached.',
        errorBoundary: 'Please, clear browser cache, check internet connection and try again',
        cantConnect: "Can't connect to chat",
        fileImageLoadError: 'Incorrect file. File must be png or jpg. File limit - 5Mb'
    },
    labels: {
        noOption: 'Input your birthplace',
        copy: 'COPIED',
        startChat: 'start chat',
        dateSelect: 'Selected date must be less than the current date',
        selectDate: 'Please select a date and time',
        selectCountry: 'Enter your country',
        chooseCountry: 'Choose your country',
        online: 'Online',
        calToAction: 'START CHAT',
        determine: 'To determine your numerology (optional)',
        noAdvisor: 'No advisors were found',
        noCategory: 'No categories',
        removedChat: 'The chat has been removed',
        noActiveChat: 'You have no active chats yet',
        userHistory: 'Your history',
        forecast: "What's my love life forecast?",
        noTransaction: 'You have no transactions yet',
        thankPurchase: 'Thanks for your purchase. Check your email for further instructions.',
        purchsInfo:
            'Subscribe for {{planMessages}} messages/{{planDays}} days. Free {{trialDays}}-day trial, then just {{planPrice}}/{{planDays}} days.',
        purchsInfoWithOffer:
            'Subscribe for {{planMessages}} messages/{{planDays}} days. Free {{trialDays}}-day trial, then just <s>{{basePrice}}</s> {{planPrice}}/{{planDays}} days.',
        subscribe: 'Subscribe for {{planMessages}} messages/{{planDays}} days.',
        pay: 'Pay {{number}}',
        cancelInfo: 'Subscription can be canceled at any time from customer profile',
        termsInfo: 'By paying, you agree to the',
        updated: 'Profile successfully updated',
        emailLength: 'The email should have at most 50 characters',
        emailError: 'Email address must be a valid address',
        phone: 'Phone',
        optional: 'Optional',
        delSubscr: 'Subscription successfully deleted',
        confirmCancel: 'Confirm cancellation',
        nextPayment: 'The next payment will be charged on {{normalizedDateStr}}',
        oldLink: 'Old link no longer supported. Please update the page for new features. Apologies for any inconvenience.',
        paymentIssue: 'Payment issue.',
        paymentIssueNext: 'activation for continued access to x10 messages'
    },
    placeholders: {
        birthDate: 'Your birthplace',
        number: 'Please enter your phone number',
        numberShort: 'Enter phone number',
        birthTime: 'Your birthdate & birthtime',
        email: 'Please enter your email'
    },
    pages: {
        landing: {
            title: 'The World’s First AI Spiritual Guides'
        },
        home: {
            title: 'VEDA AI'
        },
        payment: {
            title: 'Subscribe To Continue',
            titleOffer: "Unlock today's offer!",
            title1: 'Start Free {{trialDays}}-day Trial To Continue',
            title1Offer: 'Seems like you want to chat',
            title2: 'Are you sure you want to cancel?',
            title3: 'Payment Verification issue',
            title4: 'Subscription',
            title6: 'Unlock 10x more messages',
            offerTitle: 'Special offer',
            offerLabel: 'Unlock 10x more messages',
            offerLabelTrial: 'Start trial now to secure offer',
            label: 'Subscribe to enjoy 10x more messages',
            labelOffer: 'Subscription can be canceled at any time from customer profile',
            label1: 'Subscribe to enjoy 10x more messages',
            label1Offer: "We do too, so here's a special offer for you. First month for {{price}} after your FREE {{trialDays}}-day Trial.",
            label2: 'Whenever you need answers our guides are here.',
            label3: 'Retry subscription activation for continued access to x10 messages',
            price: '{{price}} per {{planDays}} days',
            priceOn: '{{price}} per {{planDays}} days billed on {{date}}',
            advice: 'Craving More Advice?',
            moreMessages: 'Unlock {{messagesCount}} messages for {{price}}',
            paymentProcess: 'Payment processing',
            paymentProcessDescription: 'Thanks for your purchase. Check your email for further instructions.',
            paymentNotWork: 'Oops. The payment didn’t work',
            paymentNotWorkError: 'Check your internet connection and try again.',
            phoneInfo: 'Add your phone number and get updates with your horoscope every day',
            confirmDelete: 'Are you sure you want to delete?',
            messageMonth: 'Message per {{planDays}} days',
            msgAvailable: 'Messages available',
            getMore: 'Get {{messagesCount}} More Messages',
            until: 'Until:',
            active: 'active',
            inactive: 'inactive',
            planWithName: '{{planName}} subscription is',
            planWithoutName: 'Subscription is',
            bannerAlt: 'Banner avatars',
            expDate: 'Expired date',
            cardNumber: 'Card number'
        },
        chat: {
            privateLabel: 'Private chat',
            multiplyChat: '{{number}} members',
            wasRemoved: 'The chat was deleted',
            wasRemovedRequest: 'Please select the most relevant option for you',
            confirmDelete: 'Are you sure you want to delete the "{{-chatName}}"?',
            confirmDeleteText: 'Whenever you need answers our guides are here.',
            toMarketplace: 'Navigate on Marketplace',
            createChat: 'Create chat with {{alias}}'
        },
        userDeletionStatus: {
            requestNotFound: 'Request {{code}} was not found',
            requestStatus: 'Request {{code}} is {{status}}',
            emptyCodeError: 'Something went wrong - the code is empty',
            unknownError: 'Something went wrong while checking the request {{code}}. Please, try again later',
            updateStatus: 'Update status'
        }
    },
    modal: {
        title1: 'WANT TO KEEP THE CONVERSATION GOING?',
        label1: 'Sign up for unlimited access!',
        label2: 'Delete this chat? ',
        label3: 'You will not be able to restore it again',
        label4: 'To determine your zodiac sign (optional)',
        multiTitle: 'Share this chat to unlock group insights',
        multiSubtitle: 'Invite others to join the chat',
        authSecondTitle: 'Add birth details for more accurate readings and guidance'
    },
    toastMessages: {
        noSupportLink: 'Old link no longer supported. Please update the page for new features. Apologies for any inconvenience.'
    }
};
